import { css } from '@emotion/react'
import { SpacingToken, Text } from '@livechat/design-system-react-components'

const copyCss = css`
  margin: var(${SpacingToken.Spacing5}) 0 0;
`

const VerifiedCopy = () => (
  <Text css={copyCss} data-test="verified-copy">
    In {process.env.GATSBY_PRODUCT_LABEL}, we always appreciate creative and
    problem-solving apps, so at our own sole discretion, from time to time, we
    may grant some applications the “Verified” status (represented by a badge or
    so-called badged applications). The „Verified” status confirms only that an
    application went through our usability review from the user's perspective.
    In any case, it is the Application Provider who has full responsibility for
    the application and its security level towards clients and any other third
    party.
  </Text>
)

export default VerifiedCopy
